export default "__VITE_ASSET__3664a1ee__"